import { useQuery } from "@tanstack/react-query";
import { GetSubscriptions } from "@/api/services/subscriptions";
import { ISubscriptionListParams } from "@/api/types/subscription";

export function useSubscriptions(params: ISubscriptionListParams) {
    return useQuery({
        queryKey: ["subscriptions", params],
        queryFn: () => GetSubscriptions(params),
    });
}
